import request from "@/utils/request";
import axios from 'axios';
import qs from "qs";


/**
 * 查询提现申请
 * @param params
 * @returns {*}
 */
export function getWithdrawalList(params) {
  return request({
    url: "/withdrawal/getList",
    method: "get",
    params
  });
}
/**
 * 查询提现申请【导出】
 * @param params
 * @returns {*}
 */
export function exportList(params) {
  return request({
    url: "/withdrawal/exportList",
    method: "get",
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    params
  });
}

/**
 * 提现申请回执
 * @param params
 * @returns {*}
 */

/**
 * 查询交易所兑换单列表
 * @param params
 * @returns {*}
 */
export function getExchtradeList(params) {
  return request({
    url: "/exchtrade/getList",
    method: "get",
    params
  });
}

export function getWithdrawRecordList(params) {
  return request({
    url: "/withdraw/getWithdrawRecordList",
    method: "get",
    params
  });
}
export function feedback(params) {
  return request.post("/withdrawal/feedback", qs.stringify(params));
}
export function wechatCancelTransfer(params) {
  return request.post("/withdraw/wechatCancelTransfer", qs.stringify(params));
}
export function getSettlementList(params) {
  return request({
    url: "/orderSettlement/getOrderFinanceSettlementList",
    method: "get",
    params
  });
}
export function exportOrderFinance(params) {
  return request({
    url: "/orderSettlement/exportOrderFinance",
    method: "get",
    params
  });
}
// export function batchSettlementOrder(params) {
//   return request.post("/orderSettlement/batchSettlementOrder", qs.stringify(params));
// }
// 新增代理商配置
export function batchSettlementOrder(params) {
  return request({
    url: "/orderSettlement/batchSettlementOrder",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export function reviewWithdrawTbc(params) {
  return request.post("/exchtrade/reviewWithdrawTbc", qs.stringify(params));
}



// export function wechatCancelTransfer(params) {
//   return request.post("/orderSettlement/getOrderFinanceSettlementList", qs.stringify(params));
// }
